module.exports = __webpack_public_path__ + "static/media/32-3.8d4eaa79.mp3";